import { render } from "./tournament-detail-modal.template.html?vue&type=template&id=43302702&scoped=true"
import script from "./TournamentDetailModal.vue?vue&type=script&lang=ts"
export * from "./TournamentDetailModal.vue?vue&type=script&lang=ts"

import "./TournamentDetailModal.vue?vue&type=style&index=0&id=43302702&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43302702"

export default script